import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DataService } from './data.service';

@Injectable({
    providedIn: 'root',
})
export class lteManageInventoryService {
    constructor(private http: HttpClient, private dataService: DataService) { }

    getLTEDevicesList() {
        return this.dataService.getRecord('/api/LTE/GetLTEDevices');
    }
    getLTEDevicesByServiceProviderId(serviceProviderId) {
        return this.dataService.getRecord('/api/LTE/GetLTESIMByID/'+serviceProviderId);
    }

    getLTERoutersList() {
        return this.dataService.getRecord('/api/LTE/GetLTERouters');
    }
    SaveModeOfDispatch(payload) {
        return this.dataService.post('/api/DeviceAllocation/SaveModeOfDispatch/', payload);
    }
    CreateCustomerinSkynetandHC(appId) {
        return this.dataService.getRecord('/api/LTE/CreateCustomerinsandvineandHC/' + appId);
    }
    CreateWaybillfromskynet(appId) {
        return this.dataService.getRecord('/api/LTE/CreateCustomerinsandvineandHC/' + appId);
    }
    LTETopupHistory(data) {
        const query = data.searchQuery ? `?SearchQuery=${encodeURIComponent(data.searchQuery)}` : '';
        return this.dataService.getRecord('/api/LTE/GetLTETopupHistory' + query);
    }
}